import { useLocale } from '../i18n/LocaleContext'
import SEOHead from '../components/SEOHead'

export default function CookiePolicy() {
  const { t } = useLocale()

  return (
    <section className="section-padding bg-white">
      <SEOHead title={t.cookies.metaTitle} description={t.cookies.metaDescription} />
      <div className="container-max max-w-3xl">
        <h1 className="mb-2">{t.cookies.title}</h1>
        <p className="text-text-muted text-sm mb-8">{t.cookies.lastUpdated}</p>

        <div className="space-y-8">
          {t.cookies.content.map((section, i) => (
            <div key={i}>
              <h2 className="text-xl font-heading font-medium mb-3">{section.heading}</h2>
              <div className="text-text-secondary leading-relaxed whitespace-pre-line">
                {section.text}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
